import client from '..';

const environment = process ? process.env : null;

export interface BluonAITokenResponse {
  data: {
    token: string;
  };
}

export async function getBluonAIToken(): Promise<BluonAITokenResponse> {
  const { data } = await client.get(
    `/${environment?.REACT_APP_API_VERSION}/auth/bluon-ai-token`,
  );

  return data;
}
